export const GLOBAL_STATE = 'demoLessonEvaluation'

export const DEMO_LESSON_EVALUATION_LIST = 'DEMO_LESSON_EVALUATION_LIST' as const
export const DEMO_LESSON_EVALUATION_CREATE = 'DEMO_LESSON_EVALUATION_CREATE' as const
export const DEMO_LESSON_EVALUATION_CATEGORY = 'DEMO_LESSON_EVALUATION_CATEGORY' as const
export const DEMO_LESSON_EVALUATION_REPORT = 'DEMO_LESSON_EVALUATION_REPORT' as const
export const DEMO_LESSON_EVALUATION_PRINCIPAL = 'DEMO_LESSON_EVALUATION_PRINCIPAL' as const
export const DEMO_LESSON_EVALUATION_ASSIGNED = 'DEMO_LESSON_EVALUATION_ASSIGNED' as const

export const DEMO_LESSON_EVALUATION_RESPONSE_CREATE = 'DEMO_LESSON_EVALUATION_RESPONSE_CREATE' as const
export const DEMO_LESSON_EVALUATION_RESPONSE_ALL = 'DEMO_LESSON_EVALUATION_RESPONSE_ALL' as const

export const DEMO_LESSON_COURSE = 'DEMO_LESSON_COURSE' as const
export const DEMO_LESSON_COURSE_CREATE = 'DEMO_LESSON_COURSE_CREATE' as const
export const DEMO_LESSON_COURSE_DELETE = 'DEMO_LESSON_COURSE_DELETE' as const
export const DEMO_LESSON_COURSE_LIST = 'DEMO_LESSON_COURSE_LIST' as const
export const DEMO_LESSON_COURSE_ALL = 'DEMO_LESSON_COURSE_ALL' as const

export const DEMO_LESSON_MODULE = 'DEMO_LESSON_MODULE' as const
export const DEMO_LESSON_MODULE_CREATE = 'DEMO_LESSON_MODULE_CREATE' as const
export const DEMO_LESSON_MODULE_DELETE = 'DEMO_LESSON_MODULE_DELETE' as const
export const DEMO_LESSON_MODULE_LIST = 'DEMO_LESSON_MODULE_LIST' as const
export const DEMO_LESSON_MODULE_ALL = 'DEMO_LESSON_MODULE_ALL' as const
